export function getOrgMeta(orgSlug, callback) {
  const xhr = new XMLHttpRequest()
  xhr.open('GET', `/api/v1/org/${orgSlug}/meta`)
  xhr.timeout = 30000
  xhr.addEventListener('load', evt => {
    if (evt.target.status === 200) {
      try {
        callback(JSON.parse(evt.target.response))
      } catch (e) {
        callback(null)
      }
    } else {
      callback(null)
    }
  })
  xhr.addEventListener('error', () => callback(null))
  xhr.addEventListener('timeout', () => callback(null))
  xhr.send()
}
